import Header from 'modules/header/farm/main';
import PurchaseSubproducts from 'modules/purchase/purchaseSubproducts';
import React from 'react';

const PurchaseSubproductsContainer = () => {
  return (
    <div className="flex w-full h-full flex-col">
      <Header title="ثبت آگهی خرید" />
      <div className="flex w-full justify-center">
        <div className="  w-[90%]   flex flex-col items-center gap-4 h-full py-4 justify-center">
          <PurchaseSubproducts />
        </div>
      </div>
    </div>
  );
};

export default PurchaseSubproductsContainer;
